export const COMPANY_NAME = "WEHEAR Innovation Pvt. Ltd.";
export const TAXES = [
  {
    name: "IGST @ 9%",
    percent: 9,
  },
  {
    name: "CGST @ 9%",
    percent: 9,
  },
];

export const soldCategoriesName = {
  REPLACED: "Replacement",
  RETURNED: "Returned",
};
export const invoicePaymentStatus = {
  PAID: "paid",
  CREDIT: "credit",
};
export const companyDetails = {
  NAME: "Wehear",
  EMAIL: "info@wehear.in",
  ADDRESS: "805 , Supath ,Vijay Cross Roads , Navrangpura , Ahmedabad",
  GST: "24AACCW8915D1ZE",
  bankName: "Kotak -9090960606",
  bankIFSC: "KKBK0002588",
  bankNo: "9090960606",
  companyName: COMPANY_NAME,
};

export const SNACK_BAR_VARIETNS = {
  error: "error",
  success: "success",
  info: "info",
  warning: "warning",
};

export const actions = {
  SIGN_IN: "SIGN_IN",
  SET_USER: "SET_USER",
  SIGN_OUT: "SIGN_OUT",
  OPEN_MODAL: "OPEN_MODAL",
  CLOSE_MODAL: "CLOSE_MODAL",
  CALL_SNACKBAR_DATA: "CALL_SNACKBAR_DATA",

  SET_LIFE_STOCK_DATA: "SET_LIFE_STOCK_DATA",
  START_LIFE_STOCK_LOADING: "START_LIFE_STOCK_LOADING",

  SET_PATIENT_LOADING: "SET_PATIENT_LOADING",
  SET_PATIENT_DATA: "SET_PATIENT_DATA",
  SET_PATIENT_FILTERS: "SET_PATIENT_FILTERS",

  SET_PRODUCT_CATEGORY_DATA: "SET_PRODUCT_CATEGORY_DATA",
  START_PRODUCT_CATEGORY_LOADING: "START_PRODUCT_CATEGORY_LOADING",

  SET_INVENTORY_COUNT_DATA: "SET_INVENTORY_COUNT_DATA",
  SET_INVENTORY_COUNT_FILTERS: "SET_INVENTORY_COUNT_FILTERS",
  START_INVENTORY_COUNT_LOADING: "START_INVENTORY_COUNT_LOADING",
  SET_INVENTORY_LIST: "SET_INVENTORY_LIST",
  UPDATE_INVENTORY_LIST: "UPDATE_INVENTORY_LIST",

  SET_NOTIFICATION_DATA: "SET_NOTIFICATION_DATA",
  NOTIFICATION_READ: "NOTIFICATION_READ",

  SET_DEVICES_LIST: "SET_DEVICES_LIST",
  UPDATE_DEVICES_LIST: "UPDATE_DEVICES_LIST",
  REMOVE_DEVICE_LIST: "REMOVE_DEVICE_LIST",
  SET_ERRORS: "SET_ERRORS",
};
export const permissions = {
  ADMIN_PANEL_USERS: "ADMIN_PANEL_USERS",
  ADMIN_USERS: "ADMIN_USERS",
  USER_CREATE: "USER_CREATE",
  PATIENT_MODULE: "PATIENT_MODULE",
  USER_DELETE: "USER_DELETE",
  USERS_LISTING: "USERS_LISTING",
  LEAD_MODULE: "LEAD_MODULE",
  STOCK_MODULE: "STOCK_MODULE",
  FINANCE_MODULE: "FINANCE_MODULE",
  CRM_MANAGERS: "CRM_MANAGERS",
  USER_MANGERS: "USER_MANGERS",
  TRANSFER_DEVICES: "TRANSFER_DEVICES",

  REPLACEMENT_GENERAL: "REPLACEMENT_GENERAL",
  REPLACEMENT_APPROVE: "REPLACEMENT_APPROVE",
  REPLACEMENT_MODULE: "REPLACEMENT_MODULE",
};
export const inventoryStatus = {
  NOT_ALLOCATED: "not_allocated",
  ALLOCATED: "allocated",
  SOLD: "sold",
  CONVERTED: "converted",

  RETURNED: "returned", //when device is returned
  SOLD_WITH_REPLACEMENT: "sold_with_replacement", //when device is given to customer with replacement of defetcted device
};

export const invoiceTypes = {
  SOLD: "sold",
  TRANSFERED: "transfered",
  REGISTERED: "registered",
  RETURNED: "returned",
  REPLACED: "replaced",
};
export const salesTypes = {
  B2C: "b2c",
  B2B: "b2b",
};
export const REPLACEMENT_TICKETS_STATUS = {
  pending: "Pending",
  approved_and_pending: "Delivery Pending",

  delivered: "Delivered",
  delivery_confirmed: "Delivery Confirmed",
  rejected: "Rejected",
};

export const REPLACEMENT_TICKETS_STATUS_OBJ = {
  pending: "pending",
  approved_and_pending: "approved_and_pending",

  delivered: "delivered",
  delivery_confirmed: "delivery_confirmed",
  rejected: "rejected",
};

export const CITY = [
  { name: "Adoni" },
  { name: "Agartala" },
  { name: "Agra" },
  { name: "Ahmedabad" },
  { name: "Ahmednagar" },
  { name: "Aizawl" },
  { name: "Ajmer" },
  { name: "Akola" },
  { name: "Alappuzha" },
  { name: "Aligarh" },
  { name: "Alwar" },
  { name: "Amaravati" },
  { name: "Ambala" },
  { name: "Ambattur" },
  { name: "Ambernath" },
  { name: "Amravati" },
  { name: "Amritsar" },
  { name: "Amroha" },
  { name: "Anand" },
  { name: "Anantapur" },
  { name: "Arrah" },
  { name: "Asansol" },
  { name: "Aurangabad" },
  { name: "Avadi" },
  { name: "Bagaha" },
  { name: "Baharampur" },
  { name: "Bahraich" },
  { name: "Bally" },
  { name: "Bangalore" },
  { name: "Baranagar" },
  { name: "Barasat" },
  { name: "Bardhaman" },
  { name: "Bareilly" },
  { name: "Bathinda" },
  { name: "Begusarai" },
  { name: "Belgaum" },
  { name: "Bellary" },
  { name: "Berhampur" },
  { name: "Bettiah" },
  { name: "Bhagalpur" },
  { name: "Bhalswa Jahangir Pur" },
  { name: "Bharatpur" },
  { name: "Bhatpara" },
  { name: "Bhavnagar" },
  { name: "Bhilai" },
  { name: "Bhilwara" },
  { name: "Bhimavaram" },
  { name: "Bhind" },
  { name: "Bhiwandi" },
  { name: "Bhiwani" },
  { name: "Bhopal" },
  { name: "Bhubaneswar" },
  { name: "Bhusawal" },
  { name: "Bidar" },
  { name: "Bidhan Nagar" },
  { name: "Bihar Sharif" },
  { name: "Bijapur" },
  { name: "Bikaner" },
  { name: "Bilaspur" },
  { name: "Bokaro" },
  { name: "Bulandshahr" },
  { name: "Burhanpur" },
  { name: "Buxar" },
  { name: "Chandigarh" },
  { name: "Chandrapur" },
  { name: "Chapra" },
  { name: "Chennai" },
  { name: "Chittoor" },
  { name: "Coimbatore" },
  { name: "Cuttack" },
  { name: "Danapur" },
  { name: "Darbhanga" },
  { name: "Davanagere" },
  { name: "Dehradun" },
  { name: "Dehri" },
  { name: "Delhi" },
  { name: "Deoghar" },
  { name: "Dewas" },
  { name: "Dhanbad" },
  { name: "Dharmavaram" },
  { name: "Dhule" },
  { name: "Dindigul" },
  { name: "Durg" },
  { name: "Durgapur" },
  { name: "Eluru" },
  { name: "Erode" },
  { name: "Etawah" },
  { name: "Faridabad" },
  { name: "Farrukhabad" },
  { name: "Fatehpur" },
  { name: "Firozabad" },
  { name: "Gandhidham" },
  { name: "Gandhinagar" },
  { name: "Gaya" },
  { name: "Ghaziabad" },
  { name: "Gopalpur" },
  { name: "Gorakhpur" },
  { name: "Gudivada" },
  { name: "Gulbarga" },
  { name: "Guna" },
  { name: "Guntakal" },
  { name: "Guntur" },
  { name: "Gurgaon" },
  { name: "Guwahati" },
  { name: "Gwalior" },
  { name: "Hajipur" },
  { name: "Haldia" },
  { name: "Hapur" },
  { name: "Haridwar" },
  { name: "Hindupur" },
  { name: "Hospet" },
  { name: "Howrah" },
  { name: "Hubballi-Dharwad" },
  { name: "Hugli and Chinsurah" },
  { name: "Hyderabad" },
  { name: "Ichalkaranji" },
  { name: "Imphal" },
  { name: "Indore" },
  { name: "Jabalpur" },
  { name: "Jaipur" },
  { name: "Jalandhar" },
  { name: "Jalgaon" },
  { name: "Jalna" },
  { name: "Jamalpur" },
  { name: "Jammu" },
  { name: "Jamnagar" },
  { name: "Jamshedpur" },
  { name: "Jaunpur" },
  { name: "Jehanabad" },
  { name: "Jhansi" },
  { name: "Jodhpur" },
  { name: "Junagadh" },
  { name: "Kadapa" },
  { name: "Kakinada" },
  { name: "Kalyan-Dombivali" },
  { name: "Kamarhati" },
  { name: "Kanpur" },
  { name: "Karaikudi" },
  { name: "Karawal Nagar" },
  { name: "Karimnagar" },
  { name: "Karnal" },
  { name: "Katihar" },
  { name: "Kavali" },
  { name: "Khammam" },
  { name: "Khandwa" },
  { name: "Kharagpur" },
  { name: "Khora" },
  { name: "Kirari Suleman Nagar" },
  { name: "Kishanganj" },
  { name: "Kochi" },
  { name: "Kolhapur" },
  { name: "Kolkata" },
  { name: "Kollam" },
  { name: "Korba" },
  { name: "Kota" },
  { name: "Kottayam" },
  { name: "Kozhikode" },
  { name: "Kulti" },
  { name: "Kurnool" },
  { name: "Latur" },
  { name: "Loni" },
  { name: "Lucknow" },
  { name: "Ludhiana" },
  { name: "Machilipatnam" },
  { name: "Madanapalle" },
  { name: "Madhyamgram" },
  { name: "Madurai" },
  { name: "Mahesana" },
  { name: "Maheshtala" },
  { name: "Malda" },
  { name: "Malegaon" },
  { name: "Mangalore" },
  { name: "Mango" },
  { name: "Mathura" },
  { name: "Mau" },
  { name: "Meerut" },
  { name: "Mira-Bhayandar" },
  { name: "Miryalaguda" },
  { name: "Mirzapur" },
  { name: "Moradabad" },
  { name: "Morena" },
  { name: "Morvi" },
  { name: "Motihari" },
  { name: "Mumbai" },
  { name: "Munger" },
  { name: "Murwara" },
  { name: "Muzaffarnagar" },
  { name: "Muzaffarpur" },
  { name: "Mysore" },
  { name: "Nadiad" },
  { name: "Nagarcoil" },
  { name: "Nagpur" },
  { name: "Naihati" },
  { name: "Nanded" },
  { name: "Nandyal" },
  { name: "Nangloi Jat" },
  { name: "Narasaraopet" },
  { name: "Nashik" },
  { name: "Navi Mumbai" },
  { name: "Navi Mumbai Panvel Raigad" },
  { name: "Nellore" },
  { name: "New Delhi" },
  { name: "Nizamabad" },
  { name: "Noida" },
  { name: "North Dumdum" },
  { name: "Ongole" },
  { name: "Orai" },
  { name: "Ozhukarai" },
  { name: "Pali" },
  { name: "Pallavaram" },
  { name: "Panchkula" },
  { name: "Panihati" },
  { name: "Panipat" },
  { name: "Panvel" },
  { name: "Parbhani" },
  { name: "Patiala" },
  { name: "Patna" },
  { name: "Pimpri-Chinchwad" },
  { name: "Prayagraj" },
  { name: "Proddatur" },
  { name: "Puducherry" },
  { name: "Pune" },
  { name: "Purnia" },
  { name: "Rae Bareli" },
  { name: "Raichur" },
  { name: "Raiganj" },
  { name: "Raipur" },
  { name: "Rajahmundry" },
  { name: "Rajkot" },
  { name: "Rajpur Sonarpur" },
  { name: "Ramagundam" },
  { name: "Rampur" },
  { name: "Ranchi" },
  { name: "Ratlam" },
  { name: "Raurkela Industrial Township" },
  { name: "Rewa" },
  { name: "Rohtak" },
  { name: "Rourkela" },
  { name: "Sagar" },
  { name: "Saharanpur" },
  { name: "Saharsa" },
  { name: "Salem" },
  { name: "Sambalpur" },
  { name: "Sambhal" },
  { name: "Sangli-Miraj & Kupwad" },
  { name: "Sasaram" },
  { name: "Satara" },
  { name: "Satna" },
  { name: "Secunderabad" },
  { name: "Serampore" },
  { name: "Shahjahanpur" },
  { name: "Shimla" },
  { name: "Shivamogga" },
  { name: "Shivpuri" },
  { name: "Sikar" },
  { name: "Siliguri" },
  { name: "Singrauli" },
  { name: "Sirsa" },
  { name: "Siwan" },
  { name: "Solapur" },
  { name: "Sonipat" },
  { name: "South Dumdum" },
  { name: "Sri Ganganagar" },
  { name: "Srikakulam" },
  { name: "Srinagar" },
  { name: "Sultan Pur Majra" },
  { name: "Surat" },
  { name: "Surendranagar Dudhrej" },
  { name: "Suryapet" },
  { name: "Tadepalligudem" },
  { name: "Tadipatri" },
  { name: "Tenali" },
  { name: "Thane" },
  { name: "Thanjavur" },
  { name: "Thiruvananthapuram" },
  { name: "Thoothukudi" },
  { name: "Thrissur" },
  { name: "Tiruchirappalli" },
  { name: "Tirunelveli" },
  { name: "Tirupati" },
  { name: "Tiruppur" },
  { name: "Tiruvottiyur" },
  { name: "Tumkur" },
  { name: "Udaipur" },
  { name: "Ujjain" },
  { name: "Ulhasnagar" },
  { name: "Uluberia" },
  { name: "Unnao" },
  { name: "Vadodara" },
  { name: "Varanasi" },
  { name: "Vasai-Virar" },
  { name: "Vellore" },
  { name: "Vijayanagaram" },
  { name: "Vijayawada" },
  { name: "Visakhapatnam" },
  { name: "Warangal" },
  { name: "Yamunanagar" },
];

export const STATES = [
  { name: "Andaman and Nicobar Islands" },
  { name: "Andhra Pradesh" },
  { name: "Arunachal Pradesh" },
  { name: "Assam" },
  { name: "Bihar" },
  { name: "Chandigarh" },
  { name: "Chhattisgarh" },
  { name: "Dadra and Nagar Haveli and Daman and Diu" },
  { name: "Delhi" },
  { name: "Goa" },
  { name: "Gujarat" },
  { name: "Haryana" },
  { name: "Himachal Pradesh" },
  { name: "Jammu and Kashmir" },
  { name: "Jharkhand" },
  { name: "Karnataka" },
  { name: "Kerala" },
  { name: "Ladakh" },
  { name: "Lakshadweep" },
  { name: "Madhya Pradesh" },
  { name: "Maharashtra" },
  { name: "Manipur" },
  { name: "Meghalaya" },
  { name: "Mizoram" },
  { name: "Nagaland" },
  { name: "Odisha" },
  { name: "Puducherry" },
  { name: "Punjab" },
  { name: "Rajasthan" },
  { name: "Sikkim" },
  { name: "Tamil Nadu" },
  { name: "Telangana" },
  { name: "Tripura" },
  { name: "Uttar Pradesh" },
  { name: "Uttarakhand" },
  { name: "West Bengal" },
];

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
};

export const AFFECTED_EAR = {
  LEFT: 1,
  RIGHT: 2,
  BOTH: 3,
};

export const PATIENT_OF = {
  MICROTIA: "Microtia",
  ARTESIA: "Atresia",
  ANOTIA: "Anotia",
};

export const titleCase = (s) => {
  if (s)
    return s
      ?.toLowerCase()
      ?.replace(/^[-_]*(.)/, (_, c) => c?.toUpperCase()) // Initial char (after -/_)
      ?.replace(/[-_]+(.)/g, (_, c) => " " + c?.toUpperCase());

  return null;
};

export const findObjectKeyByValue = (value, object) => {
  for (let val in object) {
    if (object[val] == value) {
      if (val == "SN") {
        return val;
      } else {
        return titleCase(val);
      }
    }
  }
  return undefined;
};

export const ORDER_PROCESS_STATUS = {
  ORDER_RECEIVED: 1,
  ORDER_ACCEPTED: 2,
  // ORDER_REJECTED: 3,
  ORDER_SHIPPED: 3,
  // ORDER_DELIVERED: 5,
  FULFILLED: 4,
  ORDER_REJECTED: 5,
  ALL: 0,
};

export const USER_ROLES = {
  SUPER_ADMIN: 0,
  ADMIN: 1,
  PRODUCT_MANAGER: 3,
  ASSEMBLY: 4,
  RND: 7,
  DISTRIBUTOR: 18,
};
